import { CONTACT_US_EMAIL } from '@dtx-company/true-common/src/constants/contactUs'
import { FooterTextLink } from '../../FooterLink'
import { HELP_URL } from '@dtx-company/true-common/src/constants/help'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { getAppBaseUrl } from '@dtx-company/true-common/src/utils/urls/getAppBaseUrl'

export const mobileFooterData = (flowpageUrl?: string): FooterTextLink[][] => {
  const flowPageLink: FooterTextLink[] = flowpageUrl
    ? [
        {
          target: '_blank',
          href: `mailto:${CONTACT_US_EMAIL}?subject=${encodeURI(
            'Report Suspicious Flowpage'
          )}&body=${encodeURI(`I would like to report ${flowpageUrl} as suspicious.`)}`,
          label: 'Report Phishing'
        }
      ]
    : []

  return [
    [
      /* section 1 */
      {
        target: '_blank',
        href: HELP_URL,
        rel: 'noopener noreferrer nofollow',
        label: 'Help Center'
      },
      /* optional flow page link */
      ...flowPageLink,
      {
        href: new URL(Routes.PRIVACY_REQUEST, getAppBaseUrl()).toString(),
        rel: 'noopener noreferrer nofollow',
        label: 'Privacy Request'
      }
    ],
    [
      /* section 2 */
      {
        href: 'https://flow.page/privacy-policy', // Cloudflare redirects to https://www.flowcode.com/terms/privacy-policy - This is necessary to prevent backlinking from the flow.page domain to the flowcode.com domain per Google guidelines
        rel: 'noopener noreferrer nofollow',
        label: 'Privacy Policy'
      },
      {
        href: 'https://flow.page/privacy-policy#notice-at-collection', // Cloudflare redirects to https://www.flowcode.com/terms/privacy-policy - This is necessary to prevent backlinking from the flow.page domain to the flowcode.com domain per Google guidelines
        rel: 'noopener noreferrer nofollow',
        label: 'Notice at Collection'
      },
      {
        href: 'https://flow.page/terms-of-use', // Cloudflare redirects to https://www.flowcode.com/terms/terms-of-use - This is necessary to prevent backlinking from the flow.page domain to the flowcode.com domain per Google guidelines
        rel: 'noopener noreferrer nofollow',
        label: 'Terms of Use'
      }
    ]
  ]
}
